import React from 'react';
import { useFormikContext } from 'formik';
import { get } from 'lodash';

import FieldConfigurationCard from '../../FieldConfigurationCard/FieldConfigurationCard';
import ConfiguredFieldsSection from '../ConfiguredFieldsSection';

import SubSectionWrapper from './SubSectionWrapper';

const ID_PREFIX = 'configuration.involved_parties';

const ENTITIES_TYPES = {
  PERSON: 'person',
  PROPERTY: 'property',
};

// The adverse carrier is the *other* side's insurer. incident_configuration_manager's
// _involved_lob_configuration_to_incident_configuration forces these three inactive on a first party
// ("Only relevant for third parties"), and the FNOL fragment renders InvolvedInsurerFields off `active`
// with no first/third-party gate - so offering the toggles on a first party would let an admin put an
// adverse-carrier field on the insured.
const ADVERSE_CARRIER_FIELD_IDS = ['insurer_contact_id', 'insurer_reference_number', 'insurer_policy_number'];

const FIELDS_BY_ENTITY_TYPE = {
  [ENTITIES_TYPES.PERSON]: [
    'contact_id',
    'relationship_to_policyholder',
    'attorney_contact_id',
    'attorney_reference_number',
    'representative_contact_id',
    'insurer_contact_id',
    'insurer_reference_number',
    'insurer_policy_number',
    'injury_date',
  ],
  [ENTITIES_TYPES.PROPERTY]: [
    'property_description',
    'owner_contact_id',
    'attorney_contact_id',
    'attorney_reference_number',
    'insurer_contact_id',
    'insurer_reference_number',
    'insurer_policy_number',
    'injury_date',
  ],
};

const GeneralDetailsSubSection = ({ partyKey }: { partyKey: string }): JSX.Element => {
  const { values } = useFormikContext();

  const id = `${ID_PREFIX}.${partyKey}`;
  const entityType = get(values, `${id}.type`);
  const isFirstParty = get(values, `${id}.is_first_party`, false);
  const fieldIds = isFirstParty
    ? FIELDS_BY_ENTITY_TYPE[entityType].filter((fieldId) => !ADVERSE_CARRIER_FIELD_IDS.includes(fieldId))
    : FIELDS_BY_ENTITY_TYPE[entityType];

  return (
    <SubSectionWrapper title="General Details" disableIsHidden>
      {fieldIds.map((fieldId) => (
        <FieldConfigurationCard
          key={fieldId}
          idPrefix={id}
          fieldId={fieldId}
          disabledCollapse={false}
          backgroundColor={FieldConfigurationCard.BACKGROUND_COLOR.WHITE}
        />
      ))}
      <ConfiguredFieldsSection fieldId={`${id}.configured_fields`} disabled={false} withDndReorder />
    </SubSectionWrapper>
  );
};

export default GeneralDetailsSubSection;
